export default __webpack_public_path__ + "static/custom-tooltips-9fb546c3aae7b470bed7004786d9bc49.png";